
import Vue from 'vue';
import {
  Button,
  Popup,
  PopupTitle,
  PopupDescription,
  PopupActions,
} from '@descomplica/vue-components';
import { CourseModel } from '@descomplica/dex-models';
import Analytics from '@/helpers/analytics';
import { EVENT_LABELS } from '@/helpers/analytics/labels';
import PostgradBadges from '@/services/PostgradBadges';
import { getDiffTime } from '@/helpers/date';

export default Vue.extend({
  components: {
    Button,
    Popup,
    PopupTitle,
    PopupDescription,
    PopupActions,
  },
  data() {
    return {
      showPopup: PostgradBadges.shouldShowFirstWeekBadge(
        this.$store.getters.firstContentConsumedDate,
      ),
    };
  },
  computed: {
    imgSrc(): string {
      return 'https://paperx-dex-assets.s3.sa-east-1.amazonaws.com/images/1645471984903-DdHtuGZ83e.png';
    },
    currentCourse(): CourseModel {
      return this.$store.getters.currentCourse;
    },
    firstContentConsumedDate(): Date {
      return this.$store.getters.firstContentConsumedDate;
    },
  },
  watch: {
    showPopup: {
      handler(val) {
        if (val === true) {
          const diffFromFirstContentConsumedDate = getDiffTime(
            new Date().toJSON(),
            this.firstContentConsumedDate,
          );

          Analytics.trackEvent(EVENT_LABELS.modalViewed, {
            postgrad_first_week_badge_popup: true,
            course: this.currentCourse.name,
            ...(diffFromFirstContentConsumedDate && {
              days_after_first_content_consumption: diffFromFirstContentConsumedDate.days,
            }),
          });
          Analytics.trackTimeEvent(EVENT_LABELS.modalClosed);
        }
      },
      immediate: true,
    },
  },
  methods: {
    closePopup() {
      Analytics.trackEvent(EVENT_LABELS.modalClosed, {
        postgrad_first_week_badge_popup: true,
        course: this.currentCourse.name,
      });
      PostgradBadges.storeInfo('dismissed', true);

      this.showPopup = false;
    },
  },
});
